import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LayoutTwoToneSvg from "@ant-design/icons-svg/es/asn/LayoutTwoTone";
import AntdIcon from "../components/AntdIcon";
var LayoutTwoTone = function LayoutTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LayoutTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LayoutTwoTone.displayName = 'LayoutTwoTone';
}
export default /*#__PURE__*/React.forwardRef(LayoutTwoTone);